<template>
    <div v-if="editingTable.table || editingTable.deliveryData">
        <a-modal
            :footer="null"
            closable
            maskClosable
            :width="900"
            :visible="isActive"
            :zIndex="80000"
            v-model="isActive">

            <div slot="title" ref="div" tabindex="-1">
                <div class="flex justify-between items-center">
                    <div>
                        <span>{{ editingTable.table ? (`MESA ${editingTable.table.number}`).padStart(2, '0') : `DELIVERY / TAKEOUT - ${editingTable.startingFrom}` }} </span>
                        <div class="flex text-sm">
                            <span class="opacity-50 mr-2">{{ editingTable.openedOn.toDate() | moment('DD/MM/YYYY') }}</span>
                            <span>{{ editingTable.openedOn.toDate() | moment('HH:mm') }}</span>
                        </div>
                    </div>
                    <div class="flex items-center">
                        <span class="sm:hidden md:block mr-base" style="font-size: 9px; opacity: 0.4"> id: {{ editingTable.id }} </span>
                        <a-tooltip v-if="modified" :title="modified.at" style="z-index: 99999">
                            <div class="flex flex-col align-end mr-base">
                                <div class="flex items-center">
                                    <vs-avatar :text="modified.name" :src="modified.pic" class="m-0 mr-2"/>
                                    <div class="flex flex-col">
                                        <div class="text-primary text-base lineHeight">{{ modified.modification }}</div>
                                        <div class="text-sm lineHeight maxWidth truncate"> <span class="opacity-50">por</span> {{ modified.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </a-tooltip>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col sm:w-full md:w-full lg:w-7/12 xl:w-7/12 w-full">
                    <a-collapse v-model="activeAccordion">
                        <!-- USERS -->
                        <a-collapse-panel :showArrow="false" v-for="(user, i) in editingTable.usersOrders" :key="i">
                            <template v-slot:header>
                                <div class="flex">
                                    <div >
                                        <vs-checkbox :disabled="viewOnly" size="large" :class="`mt-5 ${user.id}`" v-model="user.checkedToBePay" @change="(event) => changeAllUserOrderToBePay(user)" @click="(e) => e.stopPropagation()"></vs-checkbox>
                                    </div>

                                    <div class="w-1/12">
                                        <vs-avatar :src="user.userPicture" size="large"/>
                                    </div>

                                    <div class="w-9/12 ml-10" :class="{'ml-12' : windowWidth < 480}">
                                        <div class="flex" style="position: relative; top:  8px;"> <h3 class="font-bold "> {{ reducedName(user.userName) }} </h3> </div>
                                        <div class="flex" style="position: relative; top: - 2px;"> <h5 class="font-semibold text-primary"> {{ user.value | currency }} </h5> </div>
                                    </div>
                                </div>
                            </template>

                            <!-- USER ORDERS -->
                            <div class="mb-2" v-for="(order, z) in user.orders" :key="z">
                                <div class="flex justify-between items-center">
                                    <vs-checkbox
                                        :style=" order.status == STATUS_CANCELED || order.status == STATUS_PAID   ? 'text-decoration: line-through;' : ''"
                                        :disabled="order.status == STATUS_CANCELED || order.status == STATUS_PAID || order.status == STATUS_NOT_CONFIRMED || viewOnly" 
                                        size="large" 
                                        :class="`font-bold ${order.status == STATUS_CANCELED ? 'text-primary' : ''}`" 
                                        v-model="order.checkedToBePay">
                                            <a-icon type="check" v-if="order.status == STATUS_PAID" />
                                            {{ order.quantity }}x {{ order.product.description }} 
                                            {{ order.value ? ' - R$ ' + order.value.toFixed(2).replace('.', ',') : ''}}
                                    </vs-checkbox>
                                    <vs-dropdown vs-trigger-click style="z-index: 9999991" :disabled="order.status == STATUS_CANCELED || order.status == STATUS_PAID || viewOnly">
                                        <vs-button 
                                            size="small" 
                                            class="btn-drop"
                                            :type="order.status == STATUS_CANCELED || order.status == STATUS_PAID  || viewOnly? 'border' : 'filled'" 
                                            icon="expand_more" >
                                        </vs-button>
                                        <vs-dropdown-menu style="z-index: 999999">
                                            <!--<div v-show="order.status != STATUS_NOT_CONFIRMED">
                                                <vs-dropdown-item class="mt-4" @click="printAgain(editingTable.id, user.userId, order.id)"> <a-icon type="printer" /> REIMPRIMIR </vs-dropdown-item>
                                                <vs-divider border-style="dashed" />
                                                <vs-dropdown-item class="mt-2"> <a-icon type="edit" /> ALTERAR </vs-dropdown-item>
                                                <vs-divider border-style="dashed" />
                                            </div>-->
                                            <vs-dropdown-item v-if="order.status != STATUS_NOT_CONFIRMED" class="mt-4" @click="printAgain(editingTable.id, true, user.userId, order.id)"> <a-icon type="printer" /> REIMPRIMIR </vs-dropdown-item>
                                            <vs-dropdown-item v-if="hasManagerRole" class="mb-2 mt-2" @click="removeOrderFromUserBill(editingTable.id, user.userId, order.id)"> <a-icon type="delete" /> CANCELAR </vs-dropdown-item>
                                            <vs-dropdown-item v-if="hasManagerRole" class="mb-2" @click="editOrder(order)"> <a-icon type="edit" /> EDITAR </vs-dropdown-item>
                                        </vs-dropdown-menu>
                                    </vs-dropdown>
                                </div>

                                <div class="flex ml-10">
                                    <span class="text-sm text-grey" v-if="order.orderedAt"> 
                                        <a-icon type="clock-circle"/>
                                        Pedido as {{ convertToDate(order.orderedAt.seconds, order.orderedAt.nanoseconds) | moment('HH:mm') }}
                                    </span>
                                </div>

                                <div class="flex ml-10">
                                    <h5 class="text-primary font-bold">{{ order.status == STATUS_CANCELED ? 'CANCELADO!' : '' }}</h5>
                                    <!-- {{ order }} -->
                                </div>

                                <div class="flex ml-10">
                                    <h5 class="text-primary font-bold">{{ order.status == STATUS_NOT_CONFIRMED ? 'NÃO CONFIRMADO' : '' }}</h5>
                                </div>
                                
                                <!-- ORDER ITEMS -->
                                <div class="flex caret cursor-pointer" @click="showOptions(i, z)" v-if="Object.keys(order.options).length > 0">
                                    <a-icon :type="!order.showOptions ? 'caret-right' : 'caret-down'" class="caretOption"   />
                                    <span class="w-full caretText ml-1" v-if="!order.showOptions">Mostrar opções</span>
                                </div>

                                <transition name="slide">
                                    <div :key="1" v-if="order.showOptions" @click="showOptions(i, z)" class="cursor-pointer">
                                        <div class="mb-2 ml-10" v-for="(option, x) in order.options" :key="x">
                                            <div class=" font-semibold">
                                                {{ option.description }}
                                            </div>
                                            <div class="ml-4" v-for="(item, y) in option.items" :key="y">
                                                <span v-if="option.type != 'single'"> {{ (item.selected ? item.selected : 1) }}x {{ item.description }} {{ item.value > 0 ? ' - R$ ' + (item.value * item.selected).toFixed(2).replace('.',',') : '' }}</span>
                                                <span v-else class="ml-2"> {{ item.description }} {{ item.value > 0 ? ' - R$ ' + (item.value * (item.selected || 1)).toFixed(2).replace('.',',') : '' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </transition>

                                <div :class="Object.keys(order.options).length > 0 ? 'mt-8' : ''">
                                    <div class="flex mb-2 ml-10" v-if="order.forTravel" >
                                        <span class="text-danger"> <a-icon type="shopping" /> PARA VIAGEM!</span>
                                    </div>
                                    <div v-if="order.obs" class="flex mb-2 ml-10">
                                        <span><strong>OBS:</strong> {{ order.obs }}</span>
                                    </div>
                                </div>

                                <vs-divider border-style="dotted" class="mt-8" />
                            </div>
                        </a-collapse-panel>
                    </a-collapse>

                    <vs-divider border-style="dashed" class="-mb-1" color="primary" v-if="windowWidth < 480" />

                    <vs-button type="border" class="w-full mt-4" size="large" @click="$emit('add-order', table)"  v-if="!viewOnly">
                        <a-icon type="plus"/> Adicionar item
                    </vs-button>

                    <vs-divider border-style="dashed"  color="primary" v-if="windowWidth < 480" />

                </div>
                
                <div class="vx-col sm:w-full md:w-full lg:w-5/12 xl:w-5/12 w-full" visibleOnDirection="all">
                    <vx-card card-border> 
                        <div class="flex items-center justify-between">
                            <span class="font-bold">TOTAL SELECIONADO:</span>
                            <h3 class="font-bold">
                                <span v-if="windowWidth > 480"> R$ </span> 
                                <span v-if="windowWidth <= 480"> {{ totalToPay | currency }} </span>    
                                <number
                                    v-if="windowWidth > 480"
                                    ref="totalToPay"
                                    :to="totalToPay || 0"
                                    :format="(number) => number.toFixed(2).replace('.',',')"
                                    :duration="0.3"
                                    easing="Power1.easeOut"/>
                            </h3>
                        </div>

                        <template v-if="totalToPay > 0">
                            <div v-for="(tax, i) in transformedTaxes" :key="i">
                                <div class="flex items-center justify-between -mt-2 text-sm text-success font-bold" v-if="tax.enabled">
                                    <span class="font-bold">+ {{ tax.description.toUpperCase() }} ({{ tax.transformedValue }})</span>
                                    <span class="font-bold" v-if="windowWidth <= 480"> + {{ tax.calculatedValue | currency }} </span>
                                    <span v-if="windowWidth > 480">
                                        <span> + R$ </span>
                                        <number
                                            ref="totalTaxToPay"
                                            :to="tax.calculatedValue || 0"
                                            :format="(number) => number.toFixed(2).replace('.',',')"
                                            :duration="0.3"
                                            easing="Power1.easeOut"/>
                                    </span>
                                </div>
                            </div>
                        </template>

                        <vs-divider border-style="dashed" />

                        <div>
                            <div class="flex items-center justify-between text-sm font-bold">
                                <span class="font-bold"> PRODUTOS PEDIDOS: </span>
                                <span class="font-bold" v-if="windowWidth <= 480"> + {{ editingTable.value | currency }} </span>
                                <span v-if="windowWidth > 480">
                                    <span> + R$ </span>
                                    <number
                                        ref="totalTaxToPay"
                                        :to="editingTable.value"
                                        :format="(number) => number.toFixed(2).replace('.',',')"
                                        :duration="0.3"
                                        easing="Power1.easeOut"/>
                                </span>
                            </div>
                        </div>

                        <div class="flex items-center justify-between text-sm text-danger font-bold" v-if="editingTable.discountValue">
                            <span class="font-bold">- DESCONTOS</span>
                            <span class="font-bold" v-if="windowWidth <= 480"> + {{ editingTable.discountValue | currency }} </span>
                            <span v-if="windowWidth > 480">
                                <span> - R$ </span>
                                <number
                                    ref="totalTaxToPay"
                                    :to="editingTable.discountValue"
                                    :format="(number) => number.toFixed(2).replace('.',',')"
                                    :duration="0.3"
                                    easing="Power1.easeOut"/>
                            </span>
                        </div>

                        <div>
                            <div class="flex items-center justify-between text-sm text-success font-bold">
                                <span class="font-bold">+ TAXAS </span>
                                <span class="font-bold" v-if="windowWidth <= 480"> + {{ totalTaxesToPay | currency }} </span>
                                <span v-if="windowWidth > 480">
                                    <span> + R$ </span>
                                    <number
                                        ref="totalTaxToPay"
                                        :to="totalTaxesToPay"
                                        :format="(number) => number.toFixed(2).replace('.',',')"
                                        :duration="0.3"
                                        easing="Power1.easeOut"/>
                                </span>
                            </div>
                        </div>

                        <div class="flex items-center justify-between underline">
                            <span class="font-bold">TOTAL DA CONTA:</span>
                            <h4 class="font-bold">
                                <span v-if="windowWidth > 480"> R$ </span> 
                                <span v-if="windowWidth <= 480"> {{ calculatedTotalToPay | currency }} </span>    
                                <number
                                    v-if="windowWidth > 480"
                                    ref="total"
                                    :to="calculatedTotalToPay"
                                    :format="(number) => number.toFixed(2).replace('.',',')"
                                    :duration="0.3"
                                    easing="Power1.easeOut"/>
                            </h4>
                        </div>                        

                        <vs-divider  />

                        <div class="flex items-center justify-between text-sm">
                            <span class="font-bold">PRODUTOS PAGOS:</span>
                            <span class="font-bold">
                                <span v-if="windowWidth > 480"> R$ </span> 
                                <span v-if="windowWidth <= 480"> {{ editingTable.totalPaid | currency }} </span>  
                                <number
                                    v-if="windowWidth > 480"
                                    ref="totalPaid"
                                    :to="(editingTable.totalPaid ? editingTable.totalPaid : 0)"
                                    :format="(number) => number.toFixed(2).replace('.', ',')"
                                    :duration="0.3"
                                    easing="Power1.easeOut"/>
                            </span>
                        </div>

                        <div class="flex items-center justify-between text-sm text-success font-bold" v-if="editingTable.taxesValue">
                            <span class="font-bold">+ TAXAS</span>
                            <span class="font-bold" v-if="windowWidth <= 480"> + {{ editingTable.taxesValue | currency }} </span>
                            <span v-if="windowWidth > 480">
                                <span> + R$ </span>
                                <number
                                    ref="totalTaxToPay"
                                    :to="editingTable.taxesValue"
                                    :format="(number) => number.toFixed(2).replace('.',',')"
                                    :duration="0.3"
                                    easing="Power1.easeOut"/>
                            </span>
                        </div>

                        <div class="flex items-center justify-between text-sm text-success font-bold" v-if="editingTable.standalonePayment">
                            <span class="font-bold">+ PAGTO. AVULSO</span>
                            <span class="font-bold" v-if="windowWidth <= 480"> + {{ editingTable.standalonePayment | currency }} </span>
                            <span v-if="windowWidth > 480">
                                <span> + R$ </span>
                                <number
                                    ref="totalStandalone"
                                    :to="editingTable.standalonePayment"
                                    :format="(number) => number.toFixed(2).replace('.',',')"
                                    :duration="0.3"
                                    easing="Power1.easeOut"/>
                            </span>
                        </div>

                        <div class="flex items-center justify-between mt-2 underline" >
                            <span class="font-bold">TOTAL PAGO:</span>
                            <span class="font-bold" v-if="windowWidth <= 480"> + {{ totalPaidPlusOthers | currency }} </span>
                            <h4 v-if="windowWidth > 480">
                                <span class="font-bold"> R$ </span>
                                <number
                                    class="font-bold"
                                    ref="totalPaid"
                                    :to="totalPaidPlusOthers"
                                    :format="(number) => number.toFixed(2).replace('.',',')"
                                    :duration="0.3"
                                    easing="Power1.easeOut"/>
                            </h4>
                        </div>
                    </vx-card>

                    <vx-card card-border class="mt-3"> 
                        <div class="flex items-center" v-if="!viewOnly">
                            <vs-button 
                                v-if="hasManagerRole"
                                :disabled="!editingTable.value || busyStatus[editingTable.id]" 
                                type="relief" 
                                class="w-full flex-1"
                                size="large" 
                                @click="showPaymentMethod()"> 
                                    <div v-if="busyStatus[editingTable.id]" class="flex">
                                        <a-icon type="loading" class="mt-1 mr-3"/> AGUARDE...
                                    </div>
                                    <div v-else>
                                        <a-icon type="dollar"/> {{ isPayingAll ? 'FECHAR CONTA' : 'PAGAR' }} 
                                    </div>
                            </vs-button>

                            <vs-dropdown vs-trigger-click class="xs:hide md:block cursor-pointer" >
                                <vs-button 
                                    v-if="hasManagerRole"
                                    :disabled="!editingTable.value || busyStatus[editingTable.id]" 
                                    type="relief" 
                                    class="px-2 ml-1"
                                    size="large"> 
                                        <div>
                                            <a-icon type="caret-down" />
                                        </div>
                                </vs-button>
                                <vs-dropdown-menu style="z-index: 999999">
                                    <p class="px-4 pt-3">Mais opções:</p>
                                    <vs-dropdown-item divider/>
                                    <vs-dropdown-item
                                        class="pb-3"
                                        @click="showOldPaymentMethod()"> 
                                        Pagamento Simplificado (Antigo)
                                    </vs-dropdown-item>
                                    <vs-dropdown-item
                                        class="pb-3"
                                        @click="() => videoHelp = true"> 
                                        Assistir vídeo
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>

                        </div>

                        <div class="flex items-center justify-between w-full mt-4" v-if="!viewOnly && hasManagerRole" >
                            <BtnCancelBill :full-btn="true" :billId="editingTable.id" v-if="hasManagerRole" />
                        </div>

                        <div class="flex items-center justify-between mt-4">
                            <vs-button type="border" :size="hasManagerRole ? 'medium' : 'large'" class="w-full" color="#939393" @click="modalPrintingMsg.visible = true"> <a-icon type="printer"> </a-icon> IMPRIMIR PEDIDOS NO CAIXA</vs-button>
                        </div>
                    </vx-card>
                </div>
            </div>
            
        </a-modal>

        <vs-popup 
            fullscreen
            :title="`MESA ${editingTable.table.number} - Pagamento/Fechamento`"
            :active.sync="modalPayment.visible"
            style="zIndex: 99998; height: 100%">
            <PaymentMethodScreen
                v-if="modalPayment.visible"
                :bill="editingTable"
                :calculatedTotalToPay="calculatedTotalToPay"
                :totalInTaxes="totalTaxesToPay"
                :usersOrdersToPay="usersIdToBePay"
                :selectedValue="totalToPay"
                @close="closePaymentsAndRestoreFocus"
                @payingAll="closeAll"
                @tutorial="() => videoHelp = true"
            />
        </vs-popup>
        
        <modal-payment-method 
            :isPayingAll="isPayingAll"
            :billId="editingTable.id"
            :discountValue="editingTable.discountValue ? editingTable.discountValue : 0"
            :ordersToBePay="ordersToBePay"
            :usersIdToBePay="usersIdToBePay"
            :totalToPay="isPayingAll ? editingTable.value + (editingTable.discountValue || 0) : totalToPay"
            :totalBillValue="editingTable.value"
            :totalPaid ="editingTable.totalPaid + (editingTable.standalonePayment || 0) "
            :visible="modalPayment.oldVisible"
            :taxes="editingTable.taxes"
            :standalonePayment="editingTable.standalonePayment ? editingTable.standalonePayment : 0"
            :taxesValue="editingTable.taxesValue"
            @close="(val) => modalPayment.oldVisible = val" />
            
        <a-modal
            :maskClosable="true"
            :width="500"
            :zIndex="99000"
            :footer="null"
            :title="`Editar ${modalEditOrder.editingOrder && modalEditOrder.editingOrder.product.description}`"
            destroyOnClose
            v-model="modalEditOrder.visible">

            <product-options
                :table="table.table"
                :productId="modalEditOrder.editingOrder && modalEditOrder.editingOrder.product.id"
                :editingOrder="modalEditOrder.editingOrder"
                @onClosePanel="modalEditOrder.visible = false"
                @saved="onSaved"/>
        </a-modal>

        <a-modal
            :wrapStyle="{top: '150px'}"
            :width="515"
            :footer="null"
            :z-index="99001"
            title="ESCOLHA A FORMA DE IMPRESSÃO"
            v-model="modalPrintingMsg.visible">
            <div class="flex w-full justify-between">
                <div>
                    <vs-button type="relief" @click="printAgain(editingTable.id, true)"> IMPRESSÃO <strong>DETALHADA</strong> </vs-button>
                </div>

                <div>
                    <vs-button type="relief" @click="printAgain(editingTable.id)"> IMPRESSÃO <strong>SIMPLES</strong>  </vs-button>
                </div>
            </div>
        </a-modal>

        <a-modal v-model="videoHelp"
            v-if="videoHelp"
            title="Nova tela de pagamento"
            :wrapStyle="{top: '150px'}"
            :width="700"
            :footer="null"
            :z-index="99998 ">
            <iframe width="660" height="415" src="https://www.youtube.com/embed/fFzvTwOATGg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </a-modal>
    </div>
</template>

<script>
    import { httpsCallable } from "@/firebase/functions";
    import firebase from '@/firebase/firebase'
    import _misc from '@/assets/utils/misc.js'
    import ModalPaymentMethod from './ModalPaymentMethod'
    import PaymentMethodScreen from '@/components/payment/Payment.vue'
    import { STATUS_CANCELED, STATUS_PAID, STATUS_CONFIRMED, STATUS_NOT_CONFIRMED } from '@/assets/utils/constants.js'
    import BtnCancelBill from '@/components/bill/BtnCancelBill'
    import ProductOptions from '@/components/product/OrderProductOptions'
    import { transformTaxes } from '@/components/taxes/Taxes.js'
    import { mapState } from 'vuex'

    export default {
        
        props : {
            visible : {
                required : true,
                type : Boolean
            },
            table : {
                required : true
            },
            viewOnly : {
                required : false,
                type: Boolean
            }
        },

        components : {
            PaymentMethodScreen,
            BtnCancelBill,
            ProductOptions,
            ModalPaymentMethod
        },

        data () {
            return {
                modalPrintingMsg : {
                    visible : false
                },
                editingTable : {},
                isActive : false,
                activeAccordion : '',
                modalPayment : {
                    visible : false,
                    oldVisible: false
                },
                modalEditOrder: {
                    visible: false,
                    editingOrder: null
                },
                transformedTaxes : [],
                videoHelp: false
            }
        },

        created () {
            this.STATUS_CANCELED = STATUS_CANCELED
            this.STATUS_PAID = STATUS_PAID
            this.STATUS_NOT_CONFIRMED = STATUS_NOT_CONFIRMED            
        },

        mounted () {
            this.isActive = this.visible
            this.$set(this.modalPayment, 'visible', false)
        },

        watch : {
            editingTable : {
                handler (val) {
                    this.transformedTaxes = transformTaxes(this.editingTable.taxes, this.totalToPay || (this.editingTable.value - this.editingTable.totalPaid))
                },
                deep : true
            },

            table : {
                handler (newValue) {
                    this.editingTable = newValue

                    if(!newValue.hasOwnProperty('totalPaid'))
                        this.$set(this.editingTable, 'totalPaid', 0)
                    if(!newValue.hasOwnProperty('taxesValue'))
                        this.$set(this.editingTable, 'taxesValue', 0)
                    if(!newValue.hasOwnProperty('discountValue'))
                        this.$set(this.editingTable, 'discountValue', 0)
                },
                deep : true
            },
            
            visible (newValue) {
                this.transformedTaxes = transformTaxes(this.editingTable.taxes, this.totalToPay || (this.editingTable.value - this.editingTable.totalPaid))
                this.isActive = newValue
            },

            isActive (newValue) {
                this.$emit('close', newValue)
            }
        },

        computed : {
            windowWidth() {
                return this.$store.state.windowWidth
            },

            calculatedTotalToPay () {
                return this.editingTable.value + this.totalTaxesToPay - this.editingTable.discountValue;
            },

            totalTaxesToPay () {
                let total = 0
                this.transformedTaxes.forEach(a => {
                    if(a.enabled){
                        if(a.name == 'percentage') {
                            total = ((a.value * this.editingTable.value) / 100)
                        }
                    }  
                }) 

                return total
            },

            totalToPay () {
                if(!this.editingTable.usersOrders) return 0

                var totalToBePaid = 0
                let usersOrders = Object.entries(this.editingTable.usersOrders)
                usersOrders.forEach(user => {
                    if (user[1]) {
                        let orders = Object.entries(user[1].orders)
                        orders.forEach(order => {
                            if(order[1]) {
                                if(order[1].checkedToBePay) {
                                    totalToBePaid += order[1].value
                                }
                            }
                        })
                    }
                })
                return totalToBePaid
            },

            totalPaidPlusOthers () {
                return (this.editingTable.totalPaid + this.editingTable.taxesValue + (this.editingTable.standalonePayment || 0))
            },

            ordersToBePay () {
                var arrOrders = []
                if(this.editingTable.usersOrders) {
                    let usersOrders = Object.entries(this.editingTable.usersOrders)
                    usersOrders.forEach(user => {
                        if (user[1]) {
                            let orders = Object.entries(user[1].orders)
                            orders.forEach(order => {
                                if(order[1]) {
                                    if(order[1].status == STATUS_CONFIRMED) {
                                        if(order[1].checkedToBePay || !this.totalToPay || this.isPayingAll)
                                            arrOrders.push(order[0])
                                    }
                                }
                            })
                        }
                    })
                }

                return arrOrders || []
            },

            usersIdToBePay () {
                var usersObj = {};
                
                if(this.editingTable.hasOwnProperty('usersOrders')) {
                    let usersOrders = Object.entries(this.editingTable.usersOrders)
                    usersOrders.forEach(([userId, userOrder]) => {
                        let orders = Object.entries(userOrder.orders)
                            .filter(([_, o]) => o.status === STATUS_CONFIRMED && (o.checkedToBePay || !this.totalToPay || this.isPayingAll))
                            .map(([id, _]) => id);
                        if (orders.length)
                            usersObj[userId] = orders;
                    })
                }
                return usersObj
            },

            isPayingAll () {
                return this.totalToPay == 0 
            },

            hasManagerRole () {
                return this.$store.getters.getUserStoredData.role < 2;
            },

            modified () {
                const { editingTable } = this;
                if (!editingTable || typeof editingTable.canceledBy !== 'object')
                    return;
                return { 
                    name: editingTable.canceledBy.name,
                    pic: editingTable.canceledBy.photoURL,
                    modification: 'Cancelada',
                    at: this.$options.filters.moment(editingTable.archivedOn.toDate(), 'HH:mm'),
                };
            },

            ...mapState('bill', ['busyStatus'])
        },

        methods : {
            convertToDate (sec, nano) {
                if(sec && nano)
                    return new firebase.firestore.Timestamp(sec, nano).toDate()

                return 'Horário desconhecido'
            },
            
            showOptions (z, i) {
                let order = this.editingTable.usersOrders[z].orders[i]
                let showOptions = order.showOptions || false
                this.$set(order, 'showOptions', !showOptions)
            },

            reducedName (name) {
                return _misc.reduceName(name)
            },

            changeAllUserOrderToBePay (user) {
                let userId = user.userId;
                let checkedToBePay = user.checkedToBePay;
                let orders = Object.entries(user.orders)
                orders.forEach((order, k) => {
                    if(order[1].status == STATUS_CONFIRMED)
                        this.$set(this.editingTable.usersOrders[userId].orders[order[0]], 'checkedToBePay', checkedToBePay)
                })
            },
            
            showPaymentMethod () {
                this.$set(this.modalPayment, 'visible', true)
            },
            showOldPaymentMethod () {
                this.$set(this.modalPayment, 'oldVisible', true)
            },

            async printAgain (billId, detailed = false, userId = null, orderId = null) {
                let date = new Date()
                let companyId = this.$store.getters.getCompanyID;
                
                try {
                    this.$vs.loading()
                    let call = httpsCallable('printOrderAgain')
                    let printAgain = await call({ companyId: companyId, billId: billId, userId: userId, orderId: orderId, isCashierPrinter : 1, detailed : detailed })
                } catch(err) {
                    this.$error({
                        zIndex : 999999,
                        title: 'Erro',
                        content: `Erro ao tentar imprimir: ${err.message}`
                    })
                } finally {
                    this.modalPrintingMsg.visible = false
                    this.$vs.loading.close()
                }
            },

            removeOrderFromUserBill (billId, userId, orderId) {
                let companyId = this.$store.getters.getCompanyID
                let that = this;

                this.$confirm({
                    zIndex: 9999998,
                    title: 'Confirme a sua intenção!',
                    content: 'Deseja realmente remover este produto da comanda?',
                    okText : 'Sim. Cancelar!',
                    cancelText: 'Não!',
                    okType: 'danger',
                    async onOk() {
                        try {
                            that.$vs.loading();

                            let call = httpsCallable('removeItemInBill')
                            let removeItem = await call({ companyId : companyId, billId : billId, orderId : orderId })
                            that.$delete(that.editingTable.usersOrders[userId].orders, orderId)
                        } catch (err) {
                            that.$error({
                                zIndex : 9999999,
                                title: 'Erro!',
                                content: `ao tentar remover produto da comanda: ${err.message}`
                            })
                        } finally {
                            that.$vs.loading.close()
                        }
                        
                    }
                })
            },
            editOrder (order) {
                this.modalEditOrder.editingOrder = order;
                this.modalEditOrder.visible = true;
            },
            onSaved () {
                this.modalEditOrder.visible = false;
            },

            closePaymentsAndRestoreFocus () {
                this.modalPayment.visible = false;
                this.$nextTick(() => {
                    this.$refs.div.focus();
                });
            },
            closeAll (nfceInfo) {
                this.modalPayment.visible = false;
                this.$emit('close', false);
                // this.$notification.info({
                //     message: 'Pagamento efetuado',
                //     description: 'Enviando nota fiscal...'
                // });
                // setTimeout(() => {
                //     this.$notification.success({
                //         message: 'Nota fiscal enviada',
                //         description: 'Mesa XX: R$ 50,00'
                //     });
                // }, 4000);
            }
        }
    }
</script>

<style scoped>
    .lineHeight {
        line-height: 1rem;
    }
    .maxWidth {
        min-width: 100px;
        max-width: 150px;
    }
</style>
<style>
    
    .caret > .caretOption {
        font-size: 20px; 
    }
    .caret > .caretText {
        text-decoration: underline;
    }

    .slide-enter-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: ease-in;
        -webkit-transition-timing-function: ease-in;
        -o-transition-timing-function: ease-in;
        transition-timing-function: ease-in;
    }

    .slide-leave-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    }

    .slide-enter-to, .slide-leave {
        max-height: 100px;
        overflow: hidden;
    }

    .slide-enter, .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }
</style>